/*
 * Side cart interactions (markup: snippets/cart-drawer.liquid).
 *
 * Every change goes through /cart/update.js or /cart/add.js with the
 * `cart-drawer` + `cart-icon-bubble` sections bundled in, then #CartDrawer
 * is swapped for the fresh render. Open/close stays in assets/cart-drawer.js;
 * this file also takes over CartDrawer#renderContents so product-page adds
 * use the same render path.
 *
 * Hallmark certificate: a separate line with the property
 * `_hallmark_for: <variant id>`, kept at the same quantity as that variant.
 *
 * Free gifts: cart-drawer.liquid works out which offer gifts the cart
 * qualifies for and, when the cart doesn't match, puts the change in
 * data-sc-gifts ({ updates: { key: qty }, add: [variant ids] }). syncGifts
 * sends it after every render, which re-renders and checks again.
 */
(function () {
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function drawer() {
    return document.querySelector('cart-drawer');
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* ---------- rendering ---------- */

  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function snapshot(el) {
    var body = el.querySelector('[data-sc-body]');
    var summary = el.querySelector('#CartDrawer-Summary');
    return {
      bodyScroll: body ? body.scrollTop : 0,
      summaryOpen: !!(summary && !summary.hidden),
      sliders: Array.prototype.map.call(el.querySelectorAll('[data-sc-slider-track]'), function (t) {
        return t.scrollLeft;
      }),
    };
  }

  function restore(el, state) {
    var body = el.querySelector('[data-sc-body]');
    if (body) body.scrollTop = state.bodyScroll;
    if (state.summaryOpen) toggleSummary(el, true);
    el.querySelectorAll('[data-sc-slider-track]').forEach(function (t, i) {
      if (state.sliders[i]) t.scrollLeft = state.sliders[i];
    });
  }

  function applySections(sections) {
    var el = drawer();
    if (!el || !sections || !sections['cart-drawer']) return;

    var fresh = parse(sections['cart-drawer']).querySelector('#CartDrawer');
    var target = el.querySelector('#CartDrawer');
    if (!fresh || !target) return;

    var state = snapshot(el);
    target.innerHTML = fresh.innerHTML;
    restore(el, state);

    var overlay = el.querySelector('#CartDrawer-Overlay');
    if (overlay) overlay.addEventListener('click', function () { el.close(); });

    var inner = el.querySelector('[data-sc-count]');
    var count = inner ? parseInt(inner.getAttribute('data-sc-count'), 10) || 0 : 0;
    el.classList.toggle('is-empty', count === 0);

    updateBubble(count, sections['cart-icon-bubble']);
    initSliders(el);
    setTimeout(syncGifts);
  }

  // The Orizza / Frost headers use their own count markup inside
  // #cart-icon-bubble, so only Dawn's header takes the section HTML.
  function updateBubble(count, bubbleHtml) {
    document.querySelectorAll('[id="cart-icon-bubble"]').forEach(function (bubble) {
      var cls = bubble.classList.contains('orizza-header__icon')
        ? 'orizza-cart-count'
        : bubble.classList.contains('frost-header__icon')
          ? 'frost-cart-count'
          : null;

      if (!cls) {
        if (!bubbleHtml) return;
        var section = parse(bubbleHtml).querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
        return;
      }

      var badge = bubble.querySelector('.' + cls);
      if (!count) {
        if (badge) badge.remove();
        return;
      }
      if (!badge) {
        badge = document.createElement('span');
        badge.className = cls;
        bubble.appendChild(badge);
      }
      badge.textContent = count;
    });
  }

  function refresh() {
    return fetch(root() + '?sections=' + SECTIONS.join(','))
      .then(function (res) { return res.json(); })
      .then(applySections)
      .catch(function (e) { console.error(e); });
  }

  /* ---------- cart requests ---------- */

  var busy = false;

  function showError(message) {
    var el = drawer();
    var box = el && el.querySelector('#CartDrawer-CartErrors');
    if (box) box.textContent = message || (window.cartStrings && window.cartStrings.error) || 'Something went wrong.';
  }

  function request(path, payload) {
    if (busy) return Promise.resolve();
    busy = true;
    var el = drawer();
    if (el) el.classList.add('sc-busy');

    payload.sections = SECTIONS;
    payload.sections_url = window.location.pathname;

    return fetch(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.status && data.description) throw new Error(data.description);
        if (data && data.errors) throw new Error(typeof data.errors === 'string' ? data.errors : '');
        applySections(data.sections);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'side-cart', cartData: data });
        }
      })
      .catch(function (e) {
        showError(e && e.message);
        return refresh();
      })
      .finally(function () {
        busy = false;
        var d = drawer();
        if (d) d.classList.remove('sc-busy');
      });
  }
    /* ---------- stock toast (same alert as the PDP) ---------- */

  var toastHost = null;
  var currentToast = null;

  function toastEl() {
    if (toastHost && document.body.contains(toastHost)) return toastHost;
    toastHost = document.createElement('div');
    toastHost.className = 'sc-toasts';
    toastHost.setAttribute('aria-live', 'assertive');
    document.body.appendChild(toastHost);
    return toastHost;
  }

  function dismissToast(toast) {
    if (!toast || toast.classList.contains('is-leaving')) return;
    toast.classList.add('is-leaving');
    var done = function () { if (toast.parentNode) toast.parentNode.removeChild(toast); };
    toast.addEventListener('animationend', function (e) { if (e.target === toast) done(); });
    setTimeout(done, 900);
    if (currentToast === toast) currentToast = null;
  }

  function showToast(message) {
    if (!message) return;
    var host = toastEl();

    // one at a time: replace the text and restart the timer
    if (currentToast) {
      currentToast.querySelector('.sc-toast-text').textContent = message;
      var bar = currentToast.querySelector('.sc-toast-bar');
      bar.style.animation = 'none';
      void bar.offsetWidth;
      bar.style.animation = '';
      return;
    }

    var toast = document.createElement('div');
    toast.className = 'sc-toast';
    toast.setAttribute('role', 'alert');
    toast.style.setProperty('--sc-toast-time', '4s');
    toast.innerHTML =
      '<svg class="sc-toast-icon" viewBox="0 0 24 24" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="11" fill="currentColor"/>' +
      '<rect x="10.75" y="5.5" width="2.5" height="8.5" rx="1.25" fill="var(--sc-toast-bg)"/>' +
      '<circle cx="12" cy="17.6" r="1.5" fill="var(--sc-toast-bg)"/></svg>' +
      '<span class="sc-toast-text"></span>' +
      '<button type="button" class="sc-toast-close" aria-label="Close">&times;</button>' +
      '<span class="sc-toast-bar" aria-hidden="true"></span>';
    toast.querySelector('.sc-toast-text').textContent = message;
    toast.querySelector('.sc-toast-close').addEventListener('click', function () { dismissToast(toast); });
    toast.querySelector('.sc-toast-bar').addEventListener('animationend', function () { dismissToast(toast); });
    host.appendChild(toast);
    currentToast = toast;
  }

  function stockMessage(limit) {
    var el = drawer();
    var text = (el && el.getAttribute('data-stock-text')) || 'Only [count] left in stock.';
    return text.split('[count]').join(String(limit));
  }

  function setQuantity(line, quantity) {
    if (busy || !line) return;
    var key = line.getAttribute('data-key');
    if (!key) return;
    var current = parseInt(line.getAttribute('data-qty'), 10) || 0;
    quantity = Math.max(0, quantity);
        // more than what's in stock: don't send, show the alert instead
    var stockAttr = line.getAttribute('data-stock');
    if (quantity > current && stockAttr !== null && stockAttr !== '') {
      var limit = parseInt(stockAttr, 10);
      if (!isNaN(limit) && quantity > limit) {
        showToast(stockMessage(limit));
        return;
      }
    }
    var updates = {};
    updates[key] = quantity;

    var hallmarkKey = line.getAttribute('data-hallmark-key');
    if (hallmarkKey) {
      var hallmarkQty = parseInt(line.getAttribute('data-hallmark-qty'), 10) || 0;
      updates[hallmarkKey] = Math.max(0, hallmarkQty - current + quantity);
    }

    var value = line.querySelector('.sc-qty__value');
    if (value) value.textContent = quantity;

    request('cart/update.js', { updates: updates });
  }

  /* ---------- free gifts ---------- */

  // The last change sent; the same one isn't retried (e.g. gift sold out),
  // so a failed request can't loop.
  var lastGiftSync = null;

  function syncGifts() {
    var el = drawer();
    var holder = el && el.querySelector('[data-sc-gifts]');
    var raw = holder ? holder.getAttribute('data-sc-gifts') : null;
    if (!raw) {
      lastGiftSync = null;
      return;
    }
    if (busy || raw === lastGiftSync) return;
    lastGiftSync = raw;

    var sync;
    try { sync = JSON.parse(raw); } catch (e) { return; }

    // Removals first; the next render then adds whatever is still missing.
    if (sync.updates && Object.keys(sync.updates).length) {
      request('cart/update.js', { updates: sync.updates });
    } else if (sync.add && sync.add.length) {
      request('cart/add.js', {
        items: sync.add.map(function (id) { return { id: Number(id), quantity: 1 }; }),
      });
    }
  }

  function addVariant(variantId, quantity, properties) {
    var item = { id: Number(variantId), quantity: quantity || 1 };
    if (properties) item.properties = properties;
    request('cart/add.js', { items: [item] });
  }

  /* ---------- UI ---------- */

  function toggleSummary(el, force) {
    var summary = el.querySelector('#CartDrawer-Summary');
    var toggle = el.querySelector('[data-sc-summary-toggle]');
    if (!summary || !toggle) return;
    var open = typeof force === 'boolean' ? force : summary.hidden;
    summary.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.classList.toggle('is-open', open);
  }

  function initSliders(el) {
    el.querySelectorAll('[data-sc-slider]').forEach(function (slider) {
      var track = slider.querySelector('[data-sc-slider-track]');
      var dots = slider.querySelector('[data-sc-dots]');
      if (!track || !dots) return;

      function pages() {
        return Math.max(1, Math.round(track.scrollWidth / Math.max(track.clientWidth, 1)));
      }

      if (dots.hasAttribute('data-sc-dots-auto')) {
        var html = '';
        for (var i = 0; i < pages(); i++) {
          html += '<button type="button" class="sc-dots__dot" data-sc-dot="' + i + '" aria-label="' + (i + 1) + ' / ' + pages() + '"></button>';
        }
        dots.innerHTML = html;
      }
      dots.hidden = pages() <= 1;

      function sync() {
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.querySelectorAll('[data-sc-dot]').forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }
      track.addEventListener('scroll', sync, { passive: true });
      sync();
    });
  }

  function onClick(event) {
    var el = event.currentTarget;
    var target = event.target;

    var qtyBtn = target.closest('[data-sc-qty]');
    if (qtyBtn) {
      var line = qtyBtn.closest('[data-sc-line]');
      var qty = parseInt(line.getAttribute('data-qty'), 10) || 0;
      setQuantity(line, qty + parseInt(qtyBtn.getAttribute('data-sc-qty'), 10));
      return;
    }

    var removeBtn = target.closest('[data-sc-remove]');
    if (removeBtn) {
      setQuantity(removeBtn.closest('[data-sc-line]'), 0);
      return;
    }

    var addBtn = target.closest('[data-sc-add]');
    if (addBtn) {
      var holder = addBtn.closest('[data-variant]');
      if (holder) addVariant(holder.getAttribute('data-variant'), 1);
      return;
    }

    if (target.closest('[data-sc-summary-toggle]')) {
      toggleSummary(el);
      return;
    }

    var dot = target.closest('[data-sc-dot]');
    if (dot) {
      var track = dot.closest('[data-sc-slider]').querySelector('[data-sc-slider-track]');
      track.scrollTo({ left: parseInt(dot.getAttribute('data-sc-dot'), 10) * track.clientWidth, behavior: 'smooth' });
    }
  }

  function onChange(event) {
    var input = event.target.closest('[data-sc-hallmark]');
    if (!input) return;
    if (busy) {
      input.checked = !input.checked;
      return;
    }

    if (input.checked) {
      addVariant(input.getAttribute('data-variant'), parseInt(input.getAttribute('data-qty'), 10) || 1, {
        _hallmark_for: input.getAttribute('data-for'),
      });
    } else {
      var line = input.closest('[data-sc-line]');
      var key = line && line.getAttribute('data-hallmark-key');
      if (!key) return;
      var updates = {};
      updates[key] = 0;
      request('cart/update.js', { updates: updates });
    }
  }

  function init() {
    var el = drawer();
    if (!el || el.hasAttribute('data-sc-ready')) return;
    el.setAttribute('data-sc-ready', '');

    el.addEventListener('click', onClick);
    el.addEventListener('change', onChange);
    initSliders(el);
    syncGifts();

    customElements.whenDefined('cart-drawer').then(function () {
      var CartDrawer = customElements.get('cart-drawer');
      var open = CartDrawer.prototype.open;

      // Product-page adds: same render path as the drawer's own updates.
      CartDrawer.prototype.renderContents = function (parsedState) {
        this.productId = parsedState.id;
        applySections(parsedState.sections);
        this._scFresh = true;
        var self = this;
        setTimeout(function () { self.open(); });
      };

      // Anything else may have changed the cart (other add-to-cart widgets),
      // so re-render on open unless we just rendered.
      CartDrawer.prototype.open = function (triggeredBy) {
        if (!this._scFresh && !this.classList.contains('active')) refresh();
        this._scFresh = false;
        return open.call(this, triggeredBy);
      };
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && (event.source === 'side-cart' || event.source === 'product-form')) return;
        refresh();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
